// import aliceJpg from 'img/shows/alice.jpg';
// import aliceWebp from 'img/shows/alice.webp';
// import sleepingJpg from 'img/shows/sleeping-adult.jpg';
// import sleepingWebp from 'img/shows/sleeping-adult.webp';
// import beastJpg from 'img/shows/beast.jpg';
// import beastWebp from 'img/shows/beast.webp';
// import jackAltonJpg from 'img/shows/jack.jpg';
// import jackAltonWebp from 'img/shows/jack.webp';
// import jackBordonJpg from 'img/shows/jack.jpg';
// import jackBordonWebp from 'img/shows/jack.webp';
// import rapunzelJpg from 'img/shows/rapunzel.jpg';
// import rapunzelWebp from 'img/shows/rapunzel.webp';
// import rapunzelBordonJpg from 'img/shows/rapunzel-bordon.jpg';
// import rapunzelBordonWebp from 'img/shows/rapunzel-bordon.webp';
// import jackAdultJpg from 'img/shows/jackAdult.jpg';
// import jackAdultWebp from 'img/shows/jackAdult.webp';
import aliceReadingJpg from 'img/shows/alice-reading.jpg';
import aliceReadingWebp from 'img/shows/alice-reading.webp';
import aliceBordonJpg from 'img/shows/alice-bordon.jpg';
import aliceBordonWebp from 'img/shows/alice-bordon.webp';
import cinderellaJpg from 'img/shows/cinderella.jpg';
import cinderellaWebp from 'img/shows/cinderella.webp';
import cinderellaReadingJpg from 'img/shows/cinderella-reading.jpg';
import cinderellaReadingWebp from 'img/shows/cinderella-reading.webp';
// import robinAdultJpg from 'img/shows/jackAdult.jpg';
// import robinAdultWebp from 'img/shows/jackAdult.webp';
import robinAdultJpg from 'img/shows/robinAdult.jpg';
import robinAdultWebp from 'img/shows/robinAdult.webp';

const isWebpSupported = () => true;

interface Venue {
  key: string;
  location: string;
  hoverText?: string;
  link: string;
  poster?: string;
};
interface Event {
  title: string;
  venues: Venue[];
  description: string;
  poster?: string;
  sub?: string;
  className?: string;
};

const links = {
  cinderella: {
    basingstoke: 'https://www.ticketsource.co.uk/pumpkinpantos/cinderella-basingstoke/e-oggdgq',
    alton: 'https://www.ticketsource.co.uk/pumpkinpantos/cinderella-alton/e-vzzkxx',
    bordon: 'https://www.ticketsource.co.uk/pumpkinpantos/cinderella-bordon/e-mqjmqa',
    reading: 'https://www.ticketsource.com/pumpkinpantos/cinderella-woodley/e-vgjbpz',
  },
  robinAdult: {
    basingstoke: 'https://www.ticketsource.co.uk/pumpkinpantos/rubbin-wood-adult-panto-basingstoke/e-vzgjmd',
    alton: 'https://www.ticketsource.co.uk/pumpkinpantos/rubbin-wood-adult-panto-alton/e-bbpzdj',
    bordon: 'https://www.ticketsource.co.uk/pumpkinpantos/rubbin-wood-adult-panto-bordon/e-agroaq',
  },
  // jackAdult: {
  //   basingstoke: 'https://www.ticketsource.co.uk/pumpkinpantos/jack-and-his-giant-stalk-adult-panto-basingstoke/e-bedogr',
  //   alton: 'https://www.ticketsource.co.uk/pumpkinpantos/jack-and-his-giant-stalk-adult-panto-alton/e-ajakdv'
  // },
  // rapunzel: {
  //   basingstoke: 'https://www.ticketsource.co.uk/pumpkinpantos/rapunzel-easter-panto-basingstoke/e-vkgjyq',
  //   alton: 'https://www.ticketsource.co.uk/pumpkinpantos/rapunzel-easter-panto-alton/e-xjmvbb',
  //   bordon:  'https://www.phoenixarts.co.uk/whats-on/events/pumpkin-pantos-presents-rapunzel-2025-08-09'
  // },
  // sleeping: {
  //   basingstoke: 'https://www.ticketsource.co.uk/pumpkinpantos/sleeping-with-beauty-basingstoke/e-obbkjq',
  //   alton: 'https://www.ticketsource.co.uk/pumpkinpantos/sleeping-with-beauty-alton/e-vlljpx'
  // },
  alice: {
    reading: 'https://www.ticketsource.com/pumpkinpantos/alice-in-wonderland-woodley/e-ljaxpa',
    bordon: 'https://www.phoenixarts.co.uk/whats-on/events/pumpkin-pantos-presents-alice-wonderland-2026-08-15'
  },
  // jack: {
  //   bordon: 'https://www.ticketsource.co.uk/pumpkinpantos/e-ayroeq',
  //   alton: 'https://www.ticketsource.co.uk/pumpkinpantos/e-zrkvre'
  // },
  // beast: {
  //   bordon: 'https://www.ticketsource.co.uk/PUMPKINPANTOS/beauty-and-the-beast-bordon/e-rkzqbo',
  //   alton: 'https://www.ticketsource.co.uk/pumpkinpantos/beauty-and-the-beast-alton/e-mympqr'
  // }
}

export const events: Event[] = [
{
  title: "2026 Christmas Panto",
  poster: isWebpSupported() ? cinderellaJpg : cinderellaWebp,
  description: `Pumpkin Pantos proudly presents the Fairy Godmother of all pantos... and you're invited to the ball!
Prepare to be swept into a world of enchanted pumpkins, glittering gowns, and fairytale magic with Cinderella — our brand-new, home-grown pantomime that's proudly local, joyfully silly, and fabulously affordable for families.
Expect toe-tapping tunes, dazzling costumes, and bucketloads of belly laughs. This sparkling production is the perfect way to kick-start your Christmas celebrations.
Featuring local favourites Josh Dixon and Ben Kennedy as the deliciously dreadful Ugly Sisters, the hilarious David Louch as Buttons, and singing sensation Ellie Henry as Cinderella.
Book early to avoid disappointment… hurry, before the clock strikes twelve!`,
  venues: [{
    key: "bordon",
    location: "Bordon",
    // hoverText: "On Sale Soon!",
    link: links.cinderella.bordon
  },{
    key: "alton",
    location: "Alton",
    // hoverText: "On Sale Soon!",
    link: links.cinderella.alton
  },{
    key: "basingstoke",
    location: "Basingstoke",
    // hoverText: "On Sale Soon!",
    link: links.cinderella.basingstoke
  },{
    key: "reading",
    location: "Woodley, Reading",
    link: links.cinderella.reading,
    poster: isWebpSupported() ? cinderellaReadingWebp : cinderellaReadingJpg,
  }]},
  {
  title: "2026 Adult Panto",
  poster: isWebpSupported() ? robinAdultJpg : robinAdultWebp,
  description: `Bend your bows, whip out your arrows, and tighten your tights—Pumpkin Pantos are back with a shaft-load of filthy fun that's guaranteed to make you quiver!
Join our well-endowed outlaw and his band of merry misfits as they take on the sordid Sheriff in a thigh-slapping romp stuffed with saucy songs, camp costumes, and grotesque gags that'll leave you hot under the codpiece.
Is Maid Marian as innocent as she seems? Can Willy Scarlett keep his weapon under wraps? And is Little John packing a big surprise?
It's Sherwood Forest like you've never seen it before!
Book now for a night of naughtiness, medieval mayhem, and more wood jokes than you can shake a staff at!`,
  venues: [{
    key: "bordon",
    location: "Bordon",
    // hoverText: "On Sale Soon!",
    link: links.robinAdult.bordon
  },{
    key: "alton",
    location: "Alton",
    // hoverText: "On Sale Soon!",
    link: links.robinAdult.alton
  },{
    key: "basingstoke",
    location: "Basingstoke",
    // hoverText: "On Sale Soon!",
    link: links.robinAdult.basingstoke
  }],
}];

interface PastEvent {
  title: string,
  venues: Omit<Venue, "link">[]
  description: string;
  poster?: string;
  className?: string;
}
// const pastEvents: PastEvent[] = [{
//   title: "Summer Panto",
//   poster: isWebpSupported() ? aliceReadingWebp : aliceReadingJpg,
//   venues: [{
//     key: "reading",
//     location: "Woodley, Reading",
//     link: links.alice.reading
//   },{
//     key: "bordon",
//     location: "Bordon",
//     link: links.alice.bordon,
//     poster: isWebpSupported() ? aliceBordonWebp : aliceBordonJpg,
//   }],
//   description: `Follow Alice down the rabbit hole to the magical world of Wonderland. Have tea with the Mad Hatter, smile with the Cheshire Cat, laugh with the Tweedles but beware of the horrid Queen of Hearts! 
// This fast-paced production is jam-packed with colourful costumes, sensational musical numbers and side-splitting comedy. So don't be late; book your tickets today. You'd be mad to miss it!`
// },{
//   title: "Adult Panto - 24-25 October 2025",
//   poster: isWebpSupported() ? jackAdultWebp : jackAdultJpg,
//   description: `Adult Panto is back... and bigger than ever!
// Pumpkin Pantos return with another filthy fairytale. Join Jack, Fairy Flickbean and Pat the Cow for a raucously rude and riotous night out!
// Expect a giant helping of innuendo, a generous splash of smut, and enough shocks to make your beanstalk tingle.
// It's cheeky! It's naughty! It's raunchy! It's everything a panto shouldn't be!`,
//   venues: [{
//     key: "alton",
//     location: "Alton",
//     // hoverText: "On Sale Soon!",
//     // link: links.jackAdult.alton
//   }],
//   className: "square"
// },{
//     title: "2025 Summer Panto",
//   poster: isWebpSupported() ? rapunzelBordonWebp : rapunzelBordonJpg,
//   description: `Follow the enchanting story of Rapunzel, the princess with magical golden hair.
// Upon learning of the princess's luscious locks, an evil sorceress named Gothel captures Rapunzel in the hope of gaining eternal beauty.
// Can Fairy Fabulous, Strider and Dolly Dumpling help to free Rapunzel from the confines of Gothel's tower?
// This hair-larious pantomime features sensational songs, colourful costumes and a laugh-a-minute script.
// So let your hair down and get ready to enjoy Pumpkin Pantos' summer spectacular!`,
//   venues: [{
//     key: "bordon",
//     location: "Bordon",
//     // hoverText: "On Sale Soon!",
//     // link: links.rapunzel.bordon
//   }]
// },
// {
//   title: "2025 Easter Panto",
//   poster: isWebpSupported() ? rapunzelWebp : rapunzelJpg,
//   description: `Follow the enchanting story of Rapunzel, the princess with magical golden hair.
// Upon learning of the princess's luscious locks, an evil sorceress named Gothel captures Rapunzel in the hope of gaining eternal beauty.
// Can Fairy Fabulous, Strider and Dolly Dumpling help to free Rapunzel from the confines of Gothel's tower?
// This hair-larious pantomime features sensational songs, colourful costumes and a laugh-a-minute script.
// So let your hair down and get ready to enjoy Pumpkin Pantos' Easter spectacular!`,
//   venues: [{
//     key: "basingstoke",
//     location: "Basingstoke",
//     // hoverText: "On Sale Soon!",
//     // link: links.rapunzel.basingstoke
//   },{
//     key: "alton",
//     location: "Alton",
//     // hoverText: "On Sale Soon!",
//     // link: links.rapunzel.alton
//   }]
// },{
//   title: "Adult's only Panto",
//   poster: isWebpSupported() ? sleepingWebp : sleepingJpg,
//   venues: [{
//     key: "basingstoke",
//     location: "Basingstoke",
//     // link: links.sleeping.basingstoke
//   },{
//     key: "alton",
//     location: "Alton",
//     // link: links.sleeping.alton,
//   }],
//   // sub: `ADULTS ONLY! 18+`,
//   description: `Prepare to be titillated and tantalised with our fabulously filthy fairytale that will leave you blushing and begging for more! 
// Meet a prince on the pull, a fairy with a flaccid wand and a sorceress hell-bent on giving the princess a little prick.  Plus there's plenty of mischief from Nurse Noo-Noo and Fiddles the Jester.
// The world of pantomime will be spun on its head in this hilarious, innuendo-filled show packed with sauce, smut and shocks. 
// It's cheeky! It's naughty! It's raunchy! It's everything a panto shouldn't be!`
//   },{
//   title: "Summer Panto",
//   venues: [{
//     key: "basingstoke",
//     location: "Basingstoke",
//   },{
//     key: "camberley",
//     location: "Camberley",
//   },{
//     key: "bordon",
//     location: "Bordon",
//   }],
//     poster: '',//<TreasurePoster></TreasurePoster>,
//     description: `Climb aboard the good ship Hispaniola and join Jimmy Hawkins on a daring quest full of pillaging pirates, deserted islands and magical mermaids. Throw in an enchanted treasure map and a perky parrot and you’ve got yourself the most exciting adventure of all time.</p>
// Jimmy must set sail across the high seas to seek a chest full of riches beyond his wildest dreams. Can our hero claim the treasure in time or will the dastardly pirates beat him to it?</p>
// This swashbuckling pantomime promises side-splitting comedy, sensational songs and audience participation in abundance!</p>
// An epic journey awaits you!`
// },{
//   title: "2022 Christmas Panto",
//   venues: [{
//     key: "alton",
//     location: "Alton",
//     hoverText: "On Sale Soon!",
//     // link: links.jack.alton,
//     poster: isWebpSupported() ? jackAltonWebp : jackAltonJpg
//   },{
//     key: "bordon",
//     location: "Bordon",
//     hoverText: "On Sale Soon!",
//     // link: links.jack.bordon,
//     poster: isWebpSupported() ? jackBordonWebp : jackBordonJpg
//   }],
//   description: `Climb up the beanstalk with Jack on a GIGANTIC adventure to find fame, fortune and true love!
// Add a lovable cow, a dastardly giant (and throw in some magic beans for good measure) and you have the perfect ingredients for a truly magnificent pantomime.
// Expect colourful costumes, bucket loads of comedy and toe-tapping musical numbers.
// It’s going to be Fe-Fi-Fo-FUN!`
// },{
//   title: "2023 Christmas Panto",
//   poster: isWebpSupported() ? beastWebp : beastJpg,
//   venues: [{
//     key: "alton",
//     location: "Alton",
//     // link: links.beast.alton
//   },{
//     key: "bordon",
//     location: "Bordon",
//     // link: links.beast.bordon
//   }],
//   description: `Pumpkin Pantos are back with another spellbinding pantomime!
// Join us for a tale as old as time; featuring a cursed prince, an enchanted rose and a magical castle.
// Can the cold-hearted Beast find true love before it's too late? Is the beautiful Belle his chance of a happy ever after? Will the funny fella in a frock return? Only time will tell...
// This promises to be a spectacular production with stunning scenery, lavish costumes, memorable songs and laughs galore.`
// },{
//   title: "Summer Panto",
//   poster: isWebpSupported() ? aliceWebp : aliceJpg,
//   venues: [{
//     key: "basingstoke",
//     location: "Basingstoke",
//     // link: links.alice.basingstoke
//   },{
//     key: "alton",
//     location: "Alton",
//     // link: links.alice.alton,
//   }],
//   description: `Follow Alice down the rabbit hole to the magical world of Wonderland. Have tea with the Mad Hatter, smile with the Cheshire Cat, laugh with the Tweedles but beware of the horrid Queen of Hearts! 
// This fast-paced production is jam-packed with colourful costumes, sensational musical numbers and side-splitting comedy. So don't be late; book your tickets today. You'd be mad to miss it!`
// }];